module.exports = "/images/lena-av.webp?dbfd39133b99ebb2c811f8dfc1690891";